module.exports = __webpack_public_path__ + "static/media/29FUNOV5.2eab1971.jpg";